"use strict";
var EnumUtil_1 = require('../EnumUtil');
var TriggerEventType_1 = require('../TriggerEventType');
var TriggerType_1 = require('../TriggerType');
var Trigger = (function () {
    function Trigger(stringName) {
        this._setName(stringName);
        this._setEventType();
        this._setUseCapture();
    }
    Trigger.prototype._setName = function (stringName) {
        var triggerValuesByName = EnumUtil_1.default.getValuesByName(TriggerType_1.default);
        var trigger = stringName.toUpperCase();
        if (trigger in triggerValuesByName) {
            this.name = triggerValuesByName[trigger];
        }
    };
    Trigger.prototype._setEventType = function () {
        switch (this.name) {
            case TriggerType_1.default.CLICK:
                this.eventType = TriggerEventType_1.default.CLICK;
                break;
            case TriggerType_1.default.BLUR:
                this.eventType = TriggerEventType_1.default.BLUR;
                break;
            case TriggerType_1.default.FOCUS:
                this.eventType = TriggerEventType_1.default.FOCUS;
                break;
            case TriggerType_1.default.HOVER:
                this.eventType = TriggerEventType_1.default.HOVER;
                break;
            case TriggerType_1.default.MANUAL:
                this.eventType = TriggerEventType_1.default.MANUAL;
                break;
            case TriggerType_1.default.MOUSEOUT:
                this.eventType = TriggerEventType_1.default.MOUSEOUT;
                break;
        }
    };
    Trigger.prototype._setUseCapture = function () {
        switch (this.name) {
            case TriggerType_1.default.FOCUS:
                this.useCapture = true;
                break;
            default:
                this.useCapture = false;
        }
    };
    return Trigger;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Trigger;
